import React from 'react';
import { ShowComponent } from '../RoleBasedComponents';
import { FaChevronDown } from 'react-icons/fa';
import './NavItem.css';

const NavItem = ({ permission, label, path, activeItem, handleClick, icon, hasDropdown, isDropdownOpen }) => {
  const isActive = activeItem === path;

  // If permission is null, render without ShowComponent
  if (permission === null) {
    return (
      <li
        className={`sideNavbar-item ${isActive ? 'active' : ''}`}
        onClick={(e) => handleClick(path, e)}
      >
        <span className="icon">{icon}</span>
        <span className="nav-text">{label}</span>
        {hasDropdown && (
          <span className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`}>
            <FaChevronDown />
          </span>
        )}
      </li>
    );
  }

  // For items with permissions, wrap in ShowComponent
  return (
    <ShowComponent permission={permission}>
      <li
        className={`sideNavbar-item ${isActive ? 'active' : ''}`}
        onClick={(e) => handleClick(path, e)}
      >
        <span className="icon">{icon}</span>
        <span className="nav-text">{label}</span>
        {hasDropdown && (
          <span className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`}>
            <FaChevronDown />
          </span>
        )}
      </li>
    </ShowComponent>
  );
};

export default NavItem;
